import { render, staticRenderFns } from "./SsoTscLogin.vue?vue&type=template&id=fe848152&scoped=true&lang=pug"
import script from "./SsoTscLogin.vue?vue&type=script&lang=js"
export * from "./SsoTscLogin.vue?vue&type=script&lang=js"
import style0 from "./SsoTscLogin.vue?vue&type=style&index=0&id=fe848152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe848152",
  null
  
)

export default component.exports